import useInterval from "./utils/useInterval";
import {saveTriggerEvents} from "./api/trigger-event";
import {useContext} from "react";
import {ReducerStateInterface} from "./interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "./GlobalReducer";
import Md5 from "./utils/Md5";

export default function TriggerEventSync() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    useInterval(() => {
        if (state.triggerEventQueue.length) {

            const first = state.triggerEventQueue.find(item => true)

            const uid = Md5((atob('RCw3TTgvMnxqYmt5') + (new Date()).toISOString().split("T")[0]) + first?.customer_identity_value)

            const triggerEventQueueWIthUid = state.triggerEventQueue.map(event => {
                event.uid = uid
                return event
            })

            console.log('Trigger Event Queue -> ', triggerEventQueueWIthUid)

            saveTriggerEvents(triggerEventQueueWIthUid);
            dispatch({
                type: ReducerActionType.CLEAR_TRIGGER_EVENT_QUEUE
            });
        }
    }, 3000)

    return <></>
}